<lib-hubio-table #table [options]="tableOptions" (rowClickEvent)="handleRowClick($event)"></lib-hubio-table>